import { AdjustmentType } from 'enums';

const AdjustmentCategoryTitles = {
    [AdjustmentType.CustomerDeduction]: 'Customer Deductions',
    [AdjustmentType.CustomerDedRepay]: 'Customer Ded. Repay',
    [AdjustmentType.DotBillback]: 'Dot Billback',
    [AdjustmentType.DotCreditToSupplier]: 'Dot Credit to Supplier',
    [AdjustmentType.Discount]: 'Discounts',
    [AdjustmentType.Invoice]: 'Invoice Adjustments',
    [AdjustmentType.Pricing]: 'Pricing Adjustment',
    [AdjustmentType.Quantity]: 'Quantity Adjustment',
    [AdjustmentType.SpecialPricing]: 'Special Pricing'
};

export default function getAdjustmentCategoryTitle(category: AdjustmentType) {
    return AdjustmentCategoryTitles[category as keyof typeof AdjustmentCategoryTitles];
}  
